export const GET_VERIFIED_USER_PLAN = "GET_VERIFIED_USER_PLAN";
export const ADD_VERIFIED_USER_PLAN = "ADD_VERIFIED_USER_PLAN";
export const UPDATE_VERIFIED_USER_PLAN = "UPDATE_VERIFIED_USER_PLAN";
export const ACTIVE_VERIFIED_USER_PLAN = "ACTIVE_VERIFIED_USER_PLAN";
export const DELETE_VERIFIED_USER_PLAN = "DELETE_VERIFIED_USER_PLAN";
